import type { SidebarNavItem } from './types';

export type SidebarSection =
  | { kind: 'group'; group: SidebarNavItem }
  | { kind: 'links'; items: SidebarNavItem[] };

/** Splits the navigation into its groups, with each run of ungrouped items as one section. */
export default function toSidebarSections(navigation: SidebarNavItem[]): SidebarSection[] {
  return navigation.reduce<SidebarSection[]>((sections, entry) => {
    if (entry.type === 'group') return [...sections, { kind: 'group', group: entry }];

    const last = sections.at(-1);
    if (last?.kind === 'links') {
      return [...sections.slice(0, -1), { kind: 'links', items: [...last.items, entry] }];
    }

    return [...sections, { kind: 'links', items: [entry] }];
  }, []);
}
